import React from 'react'
import { Link, NavLink } from "react-router-dom"
import dropdown_data from "../../Data/menu_list.json"
import DropdownDesktop from './DropdownDesktop'
import { BsPersonCircle } from "react-icons/bs"

const HeaderDesktop = () => {
  return (
    <>
        <header className="header">
            <div className="container header-container">
                <div className="logo-container">
                    <Link to="/">
                        <span className='company-logo'>Auto<span className='yellow'>Insure</span></span>
                    </Link>
                </div>
                <div className="contents-container-desktop">
                    <ul className="contents-list-desktop">
                        {dropdown_data.map((i) => {
                            return (
                                <li key={i.id} className="contents-item-desktop">
                                    <Link to={i.link}>
                                        {i.title}
                                        <DropdownDesktop list={i.dropdown} dropdownTitle={i.title}/>
                                    </Link>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div className="sign-in-container">
                    <Link to="/login">
                        <span className='sign-in-icon'><BsPersonCircle/></span>
                        <span className="sign-in-text">Sign In</span> 
                    </Link>
                </div>
            </div>
        </header>
    </>
  )
}

export default HeaderDesktop